import { render, staticRenderFns } from "./appAdminContent.vue?vue&type=template&id=581a8d74&scoped=true"
import script from "./appAdminContent.vue?vue&type=script&lang=js"
export * from "./appAdminContent.vue?vue&type=script&lang=js"
import style0 from "./appAdminContent.vue?vue&type=style&index=0&id=581a8d74&prod&lang=css"
import style1 from "./appAdminContent.vue?vue&type=style&index=1&id=581a8d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581a8d74",
  null
  
)

export default component.exports